export const PRODUCT_KPI_MONTHS_KEY = "hkp.productList.kpiMonths";

export const PRODUCT_KPI_MONTH_OPTIONS = [
  { value: 0, label: "All time" },
  { value: 1, label: "Last 1 month" },
  { value: 3, label: "Last 3 months" },
  { value: 6, label: "Last 6 months" },
  { value: 12, label: "Last 12 months" },
];

export const parseStoredKpiMonths = (raw: string | null): number => {
  const value = Number(raw);
  if (PRODUCT_KPI_MONTH_OPTIONS.some((option) => option.value === value)) {
    return value;
  }
  return 0;
};

export const createdAfterForKpiMonths = (months: number, now = new Date()): string => {
  if (!months) {
    return "";
  }
  const start = new Date(now.getTime());
  start.setMonth(start.getMonth() - months);
  return start.toISOString().slice(0, 10);
};

export const publishedStockMatches = (
  published: number,
  inStock: number,
  outOfStock: number
): boolean => Number(published) === Number(inStock) + Number(outOfStock);

export const stockCountDelta = (wasInStock: boolean, nowInStock: boolean) => {
  if (wasInStock === nowInStock) {
    return { inStock: 0, outOfStock: 0 };
  }
  return nowInStock
    ? { inStock: 1, outOfStock: -1 }
    : { inStock: -1, outOfStock: 1 };
};

export const addStockDelta = (
  current: { inStock: number; outOfStock: number },
  delta: { inStock: number; outOfStock: number }
) => ({
  inStock: Number(current.inStock) + Number(delta.inStock),
  outOfStock: Number(current.outOfStock) + Number(delta.outOfStock),
});

export const finiteCount = (value: unknown) => {
  const n = Number(value);
  return Number.isFinite(n) ? n : 0;
};

export const displayedStockCounts = (
  serverInStock: number,
  serverOutOfStock: number,
  adjust?: { inStock?: number; outOfStock?: number }
) => ({
  inStock: Math.max(0, finiteCount(serverInStock) + finiteCount(adjust?.inStock)),
  outOfStock: Math.max(0, finiteCount(serverOutOfStock) + finiteCount(adjust?.outOfStock)),
});
